import React from 'react';
import { IArticle } from '../models/article';
import { StrapiNode } from '../models/strapi';
import { ArticleCard } from './article-card';

interface ArticlesProps {
  articles: StrapiNode<IArticle>[];
}

export const Articles: React.FC<ArticlesProps> = ({ articles }) => {
  return (
    <div className="articles">
      {articles.map((article) => (
        <ArticleCard
          article={article.node}
          key={`article__left__${article.node.slug}`}
        />
      ))}
    </div>
  );
};
